import React from 'react';

interface IconArchiveProps {
    iconClasses?: string;
}

const IconArchive: React.FC<IconArchiveProps> = ({ iconClasses }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-archive ${iconClasses ?? ''}`}
            aria-hidden="true"
            stroke="currentColor"
            strokeWidth="1.16667"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="1.167" y="1.75" width="11.666" height="2.917" rx="0.583" />
            <path d="M2.333 4.667v6.416a1.167 1.167 0 0 0 1.167 1.167h7a1.167 1.167 0 0 0 1.167-1.167V4.667" />
            <path d="M5.833 7h2.334" />
        </svg>
    );
};

export default IconArchive;
